import { useEffect, useState } from 'react'
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import TransactionsList from './TransactionsList';
import TransactionsFilter from './TransactionsFilter';
import { useCurrent, usePost } from '../../hooks';
import { useTranslation } from 'react-i18next';
import { CardHeadeWithActions } from '../../components/ui';


const Transactions = () => {
    const {currentTenantId,currentCompanyId,currentBranchId,currentLangId} = useCurrent();
    const {data:transactionsResult,loading:transactionsLoading,postData:getTransactions} = usePost();
    const _urlTransactions = `${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/payment-transactions/filter`;
    const [params,setParams] = useState({
        tenant_id: currentTenantId,
        company_id: currentCompanyId,
        branch_id: currentBranchId
    });
    const [t]=useTranslation("global");

    // Filter State
    const [filterState,setFilterState] = useState({
        startDate: '',
        endDate: '',
    });
    const [paymentMethodSelected,setPaymentMethodSelected] = useState();
    const [typeSelected,setTypeSelected] = useState();
    const [userSelected,setUserSelected] = useState();
    const filterHandler = () => {
        setParams((state) =>({
            ...state,
            created_by: userSelected?.value ,
            start_date: filterState.startDate ,
            end_date: filterState.endDate ,
            type: typeSelected?.value ,
            payment_method_id: paymentMethodSelected?.value ,
        }));
        getTransactions(_urlTransactions,{
            ...params,
            created_by: userSelected?.value ,
            start_date: filterState.startDate ,
            end_date: filterState.endDate ,
            type: typeSelected?.value ,
            payment_method_id: paymentMethodSelected?.value ,
        });
    }

    //----------------------------------------------------------------

    

    const _init = () =>{
        
        getTransactions(_urlTransactions,params);
        
    }

    const paginateHandler = (_url) => {
        getTransactions(_url,params);
    }

    
    useEffect(() =>{
        _init();
    },[]);
    
    useEffect(() =>{
        if(transactionsResult){
            console.log('transactionsResult',transactionsResult)
        }
    },[transactionsResult])

    return (
        <div className='flex flex-col gap-6 pb-3'>
            <CardHeadeWithActions
                title={t("Transactions.Payments and Receipts")}
                icon={<RiMoneyDollarCircleLine size={24} />}
            />
            <div className='mt-[-10px] px-3'>
                <div className='bg-gradient-to-br from-white to-gray-50 rounded-3xl shadow-md hover:shadow-lg transition-shadow duration-300 border border-gray-100 p-6 h-full'>
                    <div className='flex flex-col xl:flex-row gap-6 items-start'>
                        <div className='flex-1 min-h-0 w-full'>
                            <TransactionsList 
                                lang={currentLangId} 
                                data={transactionsResult} 
                                loading={transactionsLoading}
                                paginateHandler = {paginateHandler}
                            />
                        </div>
                        <div className='w-full xl:w-80 flex-shrink-0'>
                            <TransactionsFilter
                                filterState = {filterState}
                                setFilterState = {setFilterState}
                                typeSelected = {typeSelected}
                                setTypeSelected = {setTypeSelected}
                                userSelected    = {userSelected}
                                setUserSelected = {setUserSelected}
                                currentTenantId = {currentTenantId}
                                currentCompanyId = {currentCompanyId}
                                currentBranchId = {currentBranchId}
                                currentLangId = {currentLangId}
                                filterHandler = {filterHandler}
                                paymentMethodSelected = {paymentMethodSelected}
                                setPaymentMethodSelected = {setPaymentMethodSelected}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Transactions
